module.exports = __webpack_public_path__ + "img/howtobreed.d4206f0d.gif";